const translateCommand = (command, offsetX, offsetY) => {
  const matches = command.match(/^(C|L|M|Z)?(?:([0-9.]+),([0-9.]+))?$/)

  const letter = matches[1]
  const x = matches[2] ? parseFloat(matches[2]) + offsetX : null
  const y = matches[3] ? parseFloat(matches[3]) + offsetY : null

  return `${letter || ''}${x !== null && y !== null ? `${x},${y}` : ''}`
}

const translatePath = (path, defaultX, defaultY, x, y) => {
  const offsetX = x - defaultX
  const offsetY = y - defaultY

  return offsetX || offsetY
    ? path.map((partialPath) =>
        partialPath
          .split(' ')
          .map((command) => translateCommand(command, offsetX, offsetY))
          .join(' ')
      )
    : path
}

export default translatePath
